export enum Currencies {
    USD = 'USD',
    EUR = 'EUR',
    GBP = 'GBP',
    BRL = 'BRL',
    MXN = 'MXN',
    ARS = 'ARS',
    CLP = 'CLP',
    COP = 'COP',
    PEN = 'PEN',
}
